<template>
  <Modal v-if="visible" :value="true" :with-footer="false" @input="closeModal">
    <span slot="header">{{ title }}</span>

    <div class="row">
      <div class="col-md-12">
        <p class="mb-3">
          Deseja realmente {{ actionLabel }} a empresa <strong>{{ company.name }}</strong>?
        </p>

        <div v-if="action === 'disable'" class="alert alert-warning text-left mb-3">
          <p class="mb-2">
            <strong>Atenção:</strong> Ao inativar esta empresa, ocorrerão as seguintes alterações no sistema:
          </p>
          <ul class="mb-0">
            <li>A empresa não será incluída nas próximas buscas de dados<span v-if="hasEmbarcador"> do CM-Embarcador</span>.</li>
            <li v-if="hasEmbarcador">A empresa deixará de aparecer no dashboard.</li>
            <li>O histórico<span v-if="hasEmbarcador"> de multas</span> será mantido e poderá ser consultado utilizando o filtro <strong>Status da empresa: Inativo</strong>.</li>
            <li>A reativação pode ser realizada a qualquer momento, se necessário.</li>
          </ul>
        </div>

        <div v-else class="alert alert-success text-left mb-3">
          <p class="mb-2">Ao reativar esta empresa, ocorrerão as seguintes alterações:</p>
          <ul class="mb-0">
            <li>A empresa ({{ company.cnpj | cnpj }}) será incluída nas próximas buscas de dados<span v-if="hasEmbarcador"> do Caçamultas Embarcador</span>.</li>
            <li v-if="hasEmbarcador">Todos os dados vinculados à empresa ({{ company.cnpj | cnpj }}) que estavam com status <strong>Inativo</strong> serão automaticamente atualizados para <strong>Ativo</strong> e voltarão a ser exibidos normalmente no dashboard.</li>
            <li v-if="hasEmbarcador">Os registros do Caçamultas Embarcador passarão novamente a ter o status Ativo.</li>
          </ul>
        </div>

        <div class="text-right mt-3">
          <button class="btn btn-outline btn-md mr-2" @click="closeModal" :disabled="loading">
            Cancelar
          </button>
          <button
            class="btn btn-md"
            :class="confirmButtonClass"
            :disabled="loading"
            @click="confirm"
          >
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import { COMPANY_STATUS } from '@/utils/companyStatus'

  export default {
    name: 'ModalToggleCompanyStatus',
    components: { Modal },
    mixins: [GetAccountApps],
    props: {
      value: { default: false, type: Boolean },
      company: { type: Object },
      action: { required: true, type: String, validator: v => ['enable', 'disable'].includes(v) }
    },
    data() {
      return { loading: false }
    },
    computed: {
      hasEmbarcador() {
        return this.getAccountApps.some(aa => aa.name === 'cm-embarcador' && aa.active)
      },
      visible() {
        return this.company && this.value
      },
      title() {
        return this.action === 'disable' ? 'Inativar Empresa' : 'Reativar Empresa'
      },
      actionLabel() {
        return this.action === 'disable' ? 'inativar' : 'reativar'
      },
      confirmLabel() {
        return this.action === 'disable' ? 'Inativar Empresa' : 'Reativar Empresa'
      },
      confirmButtonClass() {
        return this.action === 'disable' ? 'btn-outline-red' : 'btn-primary'
      }
    },
    methods: {
      closeModal() {
        if (this.loading) return
        this.$emit('input', false)
      },
      confirm() {
        if (this.loading) return
        this.loading = true

        const entityStatusId = this.action === 'disable' ? COMPANY_STATUS.DISABLED : COMPANY_STATUS.ENABLED

        this.axios.put(`companies/${this.company.id}`, { entity_status_id: entityStatusId })
          .then(response => {
            if (response && response.meta && response.meta.notice)
              this.$notify.add(response.meta.notice)
            this.$emit('confirmed', this.company)
            this.$emit('input', false)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => { this.loading = false })
      }
    }
  }
</script>

<style scoped lang="scss">
  .alert {
    border-radius: 5px;
    padding: 12px 16px;
    font-size: 14px;

    p, li, strong {
      font-size: 14px;
      line-height: 1.5;
    }

    ul {
      padding-left: 20px;
      margin-bottom: 0;
    }

    li {
      margin-bottom: 4px;
    }
  }

  .alert-warning {
    background-color: var(--alert-warning-bg) !important;
    border-color: var(--alert-warning-border) !important;
    color: var(--alert-warning-text) !important;

    p, li, strong, span {
      color: var(--alert-warning-text) !important;
    }
  }

  .alert-success {
    background-color: var(--alert-success-bg) !important;
    border-color: var(--alert-success-border) !important;
    color: var(--alert-success-text) !important;

    p, li, strong, span {
      color: var(--alert-success-text) !important;
    }
  }
</style>
